import { Injectable } from '@angular/core';
import { AbstractApiV2Service } from '../../../../api/services/abstract-api-v2.service';
import { HttpClient } from '@angular/common/http';
import { BackendErrorTranslatorService } from '../../../../services/localization/backend-error-translator.service';

interface CVRStatusData {
    customer_verification_requests_banner_status: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class CustomerVerificationRequestsStatusService extends AbstractApiV2Service<CVRStatusData> {
    public customFilters = ['parent'];
    public note = '';
    protected resourceName = 'sidenav-counts';

    constructor(http: HttpClient, backendErrorTranslator: BackendErrorTranslatorService) {
        super(http, backendErrorTranslator);
    }
}
